'use strict';

import baseConfig from './base';

let config = {
  appEnv: 'dist',  // feel free to remove the appEnv property here
  enableDevSidebarPanel: false,
  stripePublicKey: 'pk_live_0YPDAIjF3qzJ0LjQcx26msw5'
};

export default Object.freeze(Object.assign({}, baseConfig, config));



// WEBPACK FOOTER //
// ./src/config/dist.js